// extracted by mini-css-extract-plugin
module.exports = {"root":"PostMessageDrawer_root__NevKW"};